// @view
import useShortcut from './useShortcut.js';

let Shortcut = ({ keys, type, onPress }) => {
  useShortcut({ keys, type, onPress });
  return null;
};
export default Shortcut;
